

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { Oda } from "src/app/models/oda.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { OdaService } from "src/app/services/oda.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-assegna-oda-fase1",
    templateUrl: "./dialog-assegna-oda.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogAssegnaOdaFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected listaOda: Oda[]=[];
    protected isAssegnandoOda:boolean = false;
    
    protected assegnaOdaForm: FormGroup;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private odaService:OdaService
    ) {
      this.pratica          = this.config.data.pratica;
      this.listaOda         = this.config.data.listaOda;
      this.assegnaOdaForm = this.formBuilder.group({
        oda:                    [null, [Validators.required]]
      });
      
    }
    ngOnInit(): void {
      //this.loadOdaDisponibili();
    }

    loadOdaDisponibili(){
      this.isAssegnandoOda = true;
      const localizzazione:string =   this.pratica.cui.split("-")[1] === "LIG"?'LIGURIA':this.pratica.cui.split("-")[1] === 'PIE'?'PIEMONTE':'TOSCANA';
      this.odaService.getDisponibiliPerAzienda(this.pratica.idAzienda, this.pratica.bando, localizzazione).subscribe( {
        next: (v) => {
          this.logger.info(JSON.stringify(v));
            this.listaOda = v;
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da assegnare alla pratica'});
            this.isAssegnandoOda = false;
        },
        complete: () => {
            this.isAssegnandoOda = false;
           
            if(!this.listaOda || this.listaOda.length == 0){
              this.messageService.add({life: 10000,severity:'warn', summary:'ATTENZIONE', detail:'Nessun ODA disponibile per l\'azienda ed il bando selezionato'});
  
            }
        }
      }); 
    }
  
   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isAssegnandoOda = true;
        this.praticheService.assegnaODA(this.pratica.id, this.assegnaOdaForm.value.oda).subscribe( {
          next: (v) => {
            this.isAssegnandoOda = false;
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di assegnazione dell\'oda alla pratica'});
              this.isAssegnandoOda = false;
          },
          complete: () => {
              this.isAssegnandoOda = false;
             
              this.dialogRef.close({ success: true });
          }
        }); 
        
      } 
    }

  
  }